import { ModalProps } from '@mui/material'
import { useCallback } from 'react'

/**
 * モーダルの意図しない閉じ操作を防止するカスタムフック
 *
 * 背景クリックやESCキーによるモーダルの閉じ操作を無効化し、
 * 明示的な閉じるボタンのクリック時のみモーダルを閉じるようにします。
 *
 * @param onClose - モーダルを閉じる際に実行するコールバック関数
 * @returns MUIのModalコンポーネントのonCloseプロップに渡すハンドラー
 */
export const useModalClosePrevention = (
  onClose: () => void,
): ModalProps['onClose'] => {
  return useCallback(
    (_event: object, reason: string) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
        return
      }
      onClose()
    },
    [onClose],
  )
}

/**
 * 処理中のモーダルの意図しない閉じ操作を防止するカスタムフック
 *
 * 処理中(isPending=true)の場合は背景クリックやESCキーによるモーダルの閉じ操作を無効化します。
 * 処理が完了している場合は、背景クリックやESCキーでもモーダルを閉じることができます。
 *
 * @param onClose - モーダルを閉じる際に実行するコールバック関数
 * @param isPending - 処理中かどうかのフラグ
 * @returns MUIのModalコンポーネントのonCloseプロップに渡すハンドラー
 */
export const useModalClosePreventionIsPending = (
  onClose: () => void,
  isPending: boolean,
): ModalProps['onClose'] => {
  return useCallback(
    (_event: object, reason: string) => {
      if (
        isPending &&
        (reason === 'backdropClick' || reason === 'escapeKeyDown')
      ) {
        return
      }
      onClose()
    },
    [isPending, onClose],
  )
}
